import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  gap: 10px;
`

export const Column = styled(Container)`
  gap: 0px;
  margin-bottom: 5px;
`

export const CheckRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 3px;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin-bottom: 4px;

  &:hover {
    cursor: pointer;
  }
`

export const Grid = styled.div`
  width: 840px;
  display: grid;
  grid-template-columns: 70px repeat(7, 1fr);
  grid-auto-rows: 27px;
  border: 1px solid #EEEEEE;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 10px;
  overflow: hidden;
  background-color: #FFFFFF;
`

export const HeaderCell = styled.div`
  background-color: #FFFFFF;
  font-weight: 600;
  font-size: 13px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #EEEEEE;
  border-right: 1px solid #EEEEEE;

  &:last-child {
    border-right: none;
  }
`

export const TimeCell = styled.div`
  background-color: #FFFFFF;
  color: #888888;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #F0F0F0;
  border-right: 1px solid #EEEEEE;
`

export const HeatCell = styled.div`
  background-color: ${({ color }) => color};
  color: #000000;
  font-weight: 500;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #F0F0F0;
  border-right: 1px solid #EEEEEE;
  transition: background 0.2s;

  &:last-child {
    border-right: none;
  }
`
